function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavesTimeSurfaceReadyToUseWithin24Hours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65,49.94A19.24,19.24,0,1,1,45.75,30.77,19.32,19.32,0,0,1,65,49.94ZM47.29,41h0c0-1.93,0-3.85,0-5.78a1.49,1.49,0,0,0-1.45-1.66c-1.07,0-1.56.64-1.65,1.65,0,.46,0,.93,0,1.4,0,3.45-.12,6.9.05,10.33A3.44,3.44,0,0,1,42,50.78c-2.05,1-4,2.25-5.93,3.37-1,.55-1.65,1.27-1,2.39s1.61.91,2.57.35c1.81-1.06,3.64-2.1,5.45-3.16.54-.32.92-.62,1.64,0a1.42,1.42,0,0,0,2.48-1.08,2.53,2.53,0,0,1,1.26-2.08c.92-.65,1.09-1.9.09-2.31-1.52-.64-1.27-1.72-1.28-2.83C47.28,43.94,47.29,42.48,47.29,41Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.57,58.3c2.38-7,2-13.42-1.5-19.49a21.84,21.84,0,0,0-11.36-9.7A22.35,22.35,0,0,0,29.77,65.62a21.81,21.81,0,0,0,16,6.73C52,72.35,57.25,70,62,65.49a25.61,25.61,0,0,0-.79,6.27c0,.77-.62.93-1.08,1.22-15.91,10.24-37.91.46-41-18.21A27.08,27.08,0,0,1,72.21,44.18a30,30,0,0,1,.47,9.06,2,2,0,0,1-1.38,2,20.52,20.52,0,0,0-4.71,3.08Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.89,56.61A14.69,14.69,0,1,1,64.3,71.36,14.68,14.68,0,0,1,78.89,56.61ZM75.61,78.55a2.53,2.53,0,0,0,1.84-.86c3.25-3.26,6.52-6.5,9.75-9.77,1.18-1.19,1.29-2.49.28-3.35-1.24-1.06-2.33-.62-3.36.43-1.83,1.87-3.7,3.71-5.56,5.56s-3.49,1.73-5.06-.22c-.18-.23-.36-.46-.55-.68a2,2,0,0,0-3.08-.4c-1.09.9-1,2-.17,3.11,1.35,1.75,2.75,3.47,4.12,5.2a2.32,2.32,0,0,0,1.77,1Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.67,89.53c-21-.26-37-15.7-39.11-34.79C4.25,33.58,17.87,15.15,38.29,11.18a39,39,0,0,1,12.2-.42c1.14.14,2.16.47,2,1.88S51.27,14,50.21,13.91c-10.25-1.13-19.59,1.3-27.45,8-11.59,9.86-16,22.53-12.09,37.26S24.57,82.82,39.6,85.77a34.74,34.74,0,0,0,23.23-3.7,2.31,2.31,0,0,1,3.1,1.45c.12.74-.62.75-1,1a39.37,39.37,0,0,1-19.26,5Z",
    style: {
      fill: "#E66C00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.15,18.25c.43,1,.76,1.64,1,2.33a1.44,1.44,0,0,1-.75,1.92,1.37,1.37,0,0,1-2-.53c-1.13-2.24-2.21-4.5-3.19-6.8-.42-1,.2-1.68,1.15-2,2.1-.7,4.21-1.39,6.33-2,.91-.27,1.8-.16,2.15.91s-.25,1.76-1.26,2.11c-.7.25-1.42.46-2.42.79.77.47,1.28.78,1.79,1.11,13.31,8.54,19.74,20.7,19.1,36.52,0,.53.5,1.8-.79,1.58-1-.18-2.42.08-2.35-2.09.51-14.61-5.57-25.79-18-33.53A5.85,5.85,0,0,0,63.15,18.25Z",
    style: {
      fill: "#E66C00"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavesTimeSurfaceReadyToUseWithin24Hours);
export default __webpack_public_path__ + "static/media/saves-time-surface-ready-to-use-within-24-hours.9b6bbd32f396c69fb84ff77726814509.svg";
export { ForwardRef as ReactComponent };